import Vue from 'vue'
import VueRouter from "vue-router"
Vue.use(VueRouter)

import Index from '@/pages/Index'
import Login from '@/pages/Login'
import Mobile from '@/pages/Mobile'
import ManageChannel from '@/pages/manages/ManageChannel'
import ManageCloud from '@/pages/manages/ManageCloud'
import ManageCertificate from '@/pages/manages/ManageCertificate'
import ManageGroup from '@/pages/manages/ManageGroup'
import ManageRecord from '@/pages/manages/ManageRecord'
import ManageInstance from '@/pages/manages/ManageInstance'
import ManageAccount from '@/pages/manages/ManageAccount'

const routes = [
    {
        path: "/",
        component: Index
    },
    {
        path: "/login",
        component: Login
    },
    {
        path: "/mobile",
        component: Mobile
    },
    {
        path: "/manage/channel",
        component: ManageChannel
    },
    {
        path: "/manage/cloud",
        component: ManageCloud
    },
    {
        path: "/manage/certificate",
        component: ManageCertificate
    },
    {
        path: "/manage/group",
        component: ManageGroup
    },
    {
        path: "/manage/record",
        component: ManageRecord
    },
    {
        path: "/manage/instance",
        component: ManageInstance
    },
    {
        path: "/manage/account",
        component: ManageAccount
    }
]

const router = new VueRouter({
    routes,
    mode: "history"
})

router.beforeEach((to, from, next) => {
    const isMobile = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
    if (isMobile && to.path.startsWith('/mobile')) {
        next();
    } else if (isMobile && !to.path.startsWith('/mobile')) {
        next({ path: '/mobile' });
    } else if (!isMobile && to.path.startsWith('/mobile')) {
        next({ path: '/' });
    } else {
        if (to.path.startsWith('/manage')) {
            if (!sessionStorage.getItem('license')) {
                next('/login');
            } else {
                next();
            }
        } else {
            next();
        }
    }
});

export default router
